
    // IMPORTS
    import { defineComponent, PropType, computed } from 'vue'

    export default defineComponent({
        name: 'bom-icon',

        components: {},

        props: {
            type: { type: String as PropType<'replacement' | 'maintenance' | 'alternative' | 'recommended' | 'alternative-bom' | 'where-used'>, required: true },
            size: { type: Number as PropType<number>, required: false, default: 24 }
        },

        setup(props) {
            /********************************************************************************************************************
             COMPUTED DATA
             ********************************************************************************************************************/
            const classSuffix = computed(() => props.type == 'alternative-bom'
                ? props.type
                : `${props.type}-items`
            )

            const iconClasses = computed(() => [
                'k-icon',
                `icon-${classSuffix.value}`
            ])

            const containerStyle = computed(() => ({
                width: `${props.size}px`,
                height: `${props.size}px`
            }))

            const iconStyle = computed(() => ({
                fontSize: `${props.size}px`
            }))

            const computedData = { iconClasses, containerStyle, iconStyle }

            /********************************************************************************************************************
             COMPONENT INTERFACE
             ********************************************************************************************************************/
            return { ...computedData }
        }
    });
